module.exports = __webpack_public_path__ + "img/nuxt.3431a6ca.svg";